import { useState } from "react"

interface ImageProps {
  src: string,
  alt?: string,
  isSvg?: boolean,
  fadeIn?: boolean,
  className?: string
}

export const Image = (props: ImageProps) => {
  const [loaded, setLoaded] = useState(false);

  const onLoad = () => {
    setLoaded(true);
  }

  if(props.isSvg)
    return <img className={props.className || ""} src={props.src} alt={props.alt}/>

  return (
    <picture className={(loaded ? " loaded" : "")}>
      <img className={(props.className || "") + (props.fadeIn ? " fadeIn" : "")} src={props.src} alt={props.alt} loading='lazy' onLoad={onLoad}/>
    </picture>
  )
}